module.exports = __webpack_public_path__ + "img/CliEyeSet3.f278dc5e.jpg";